import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { Blog } from '../../model/blog';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { map, Observable } from 'rxjs';
import { deleteBlog, deleteBlogSuccess, loadBlog } from '../../action/blog.actions';
import { MatDialog } from '@angular/material/dialog';
import { BlogDialogComponent } from '../blog-dialog/blog-dialog.component';
import { DomSanitizer, Meta, Title } from '@angular/platform-browser';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MainserviceService } from 'src/app/mainservice.service';
import * as ngxSeo from 'ngx-seo';
import { isPlatformBrowser } from '@angular/common';
@Component({
  selector: 'app-medeil-blogs',
  templateUrl: './medeil-blogs.component.html',
  styleUrl: './medeil-blogs.component.scss'
})
export class MedeilBlogsComponent {
    blog$: any;
    gifLoader:boolean=false;
    defaultImage="assets/img/loginimg.png";
    currentPage: number = 0;
    totalPages: number = 0;
    pageSize: number = 9;
    paginatedBlogs: any[] = [];
    constructor(private store: Store<{blog:{blog:Blog[]}}>, private route: ActivatedRoute,private dialog:MatDialog,
      private router: Router,private sanitizer: DomSanitizer,private snackBar: MatSnackBar,private service:MainserviceService,private seoService: ngxSeo.SeoSocialShareService,private title:Title,private meta:Meta,@Inject(PLATFORM_ID) private platformId: Object) {
        this.setSeoMeta()
        this.gifLoader=true;
        //       this.store.dispatch(loadBlog());
        // this.store.select((state:any) => state.blog.loading).subscribe(loading => {
        //   this.gifLoader = loading;
        // });
        this.loadBlogs();

    }

    ngOnInit() {

    }

    openAddBlogDialog(): void {
    const dialogref= this.dialog.open(BlogDialogComponent, {
        width: '800px',
        data: {  }
      });
      dialogref.afterClosed().subscribe(result => {
      });
    }

    openBlogDetail(blog: Blog) {
      const decodedTitle = decodeURIComponent(blog.title);
      const formattedTitle = decodedTitle.replace(/\s+/g, "");
      console.log(formattedTitle);
      this.router.navigate(['/blog', blog.routing_title], { state: { blog } });
    }
    getImageUrl(blog: Blog): string {
      return blog.imageUrl ? blog.imageUrl : this.defaultImage;
    }
    editBlog(blog: Blog){
      const dialogRef = this.dialog.open(BlogDialogComponent, {
        width: '800px',
        data: { blog }
      });

      dialogRef.afterClosed().subscribe(result => {

      });
    }
    deleteBlog(blog:Blog){
      this.store.dispatch(deleteBlog({ id: blog.id }));
      this.snackBar.open('Blog Deleted successfully!', 'Close', { duration: 3000 });
    }
    // changePage(page: number) {
    //   if (page < 0 || page > this.totalPages) return;
    //   this.currentPage = page;
    //   this.loadBlogs();
    // }

    // getPages(): number[] {
    //   let pages = [];
    //   for (let i = 0; i <= this.totalPages-1; i++) {
    //     pages.push(i);
    //   }
    //   return pages;
    // }
    changePage(page: number): void {
      if (page < 0 || page >= this.totalPages) return;
      this.currentPage = page;
      this.updatePagination(); // Update the paginated list based on the new page
    }

    getPages(): number[] {
      return Array.from({ length: this.totalPages }, (_, i) => i); // Generates an array of page numbers
    }

    loadBlogs() {
      // this.blog$=''
      this.gifLoader = true;
      // let language=localStorage.getItem("selectedLanguage")
      // this.service.getPaginatedBlogs(this.currentPage,language,this.pageSize).subscribe(response => {
      //   this.blog$ = response.content;
      //   this.totalPages = response.totalPages;
      //   this.gifLoader = false;
      // });
        if (isPlatformBrowser(this.platformId)) {
      this.service.viewAllBlogs1().subscribe((data:any) => {
        this.blog$ = data; // Assuming response is an array of blogs
      this.totalPages = Math.ceil(this.blog$.length / this.pageSize); // Calculate the total number of pages
      this.updatePagination();
      this.gifLoader = false;
        console.log(data,'data')
      });
    }
    }
    updatePagination(): void {
      const start = this.currentPage * this.pageSize;
      const end = start + this.pageSize;
      this.paginatedBlogs = this.blog$.slice(start, end); // Slice the blog array based on the current page and page size
    }

    setSeoMeta() {
      const supportedLanguages = ['en', 'fr', 'es', 'pt'];
      let finalUrl = '';
      let lang = 'en';

      if (isPlatformBrowser(this.platformId)) {
        const origin = window.location.origin;
        const path = window.location.pathname;
        const parts = path.split('/');

        if (supportedLanguages.includes(parts[1])) {
          lang = parts[1];
        }

        const fullPath = path.replace(/^\/[a-z]{2}/, '').replace(/\/+$/, '');
        finalUrl = `${origin}/${lang}${fullPath ? '/' + fullPath : ''}`;
      }

      // Localized SEO content
      const seoTexts: any = {
        en: {
          title: 'Medeil Blogs: HealthTech & SaaS Insights',
          description: 'Explore blogs on pharmacy SaaS, digital tools, and innovations in healthcare software for better clinical operations and patient care.',
          keywords: 'Medeil blogs, healthcare SaaS, pharmacy software, digital health, medical software, clinic tech trends'
        },
        fr: {
          title: 'Blog Medeil : innovations en santé numérique',
          description: 'Découvrez nos articles sur les solutions SaaS en santé, les logiciels médicaux et la technologie dans les pharmacies et cliniques.',
          keywords: 'blog Medeil, SaaS santé, logiciel médical, pharmacie numérique, soins de santé, innovation santé'
        },
        es: {
          title: 'Blog de Medeil: SaaS y salud digital',
          description: 'Lea artículos sobre software médico, salud digital y tecnología SaaS para mejorar la atención en clínicas y farmacias.',
          keywords: 'blog Medeil, salud digital, SaaS médico, software de farmacia, innovación clínica'
        },
        pt: {
          title: 'Blog Medeil: Inovações em Saúde e SaaS',
          description: 'Acompanhe conteúdos sobre saúde digital, software médico e soluções SaaS para clínicas e farmácias modernas.',
          keywords: 'blog Medeil, saúde digital, software médico, SaaS em farmácia, tecnologia clínica'
        }
      };

      const localizedSeo = seoTexts[lang] || seoTexts['en'];

      const seoData = {
        ...localizedSeo,
        image: 'https://www.medeil.com/en/assets/medeil-pharmacy-software.jpg',
        url: finalUrl
      };

      this.title.setTitle(seoData.title);

      const metaTags = [
        { name: 'description', content: seoData.description },
        { name: 'keywords', content: seoData.keywords },
        { property: 'og:title', content: seoData.title },
        { property: 'og:description', content: seoData.description },
        { property: 'og:url', content: seoData.url },
        { property: 'og:type', content: 'website' },
        { property: 'og:image', content: seoData.image }
      ];

      metaTags.forEach(tag => this.meta.updateTag(tag));
    }

}
